import { type ColumnDef } from "@features/landing-page-analytics/types";
import { type User } from "@internal/user";
import { type GetLandingPageReportTable_me_landingPageReportTable_rows } from "@north-beam/nb-client-side";

import { type LandingPageAnalyticsTableRow } from "./types";

export function buildTableRows(
  columns: ColumnDef[],
  rows: GetLandingPageReportTable_me_landingPageReportTable_rows[],
  user: User,
) {
  const result: LandingPageAnalyticsTableRow[] = [];

  for (const [idx, dataRow] of rows.entries()) {
    const metrics: Record<string, string> = {};

    for (const column of columns) {
      if (column.metric) {
        const value = column.metric.calculate(dataRow.metrics);

        metrics[column.metric.id] = column.metric.formatter(
          value,
          user.currencies.currentCurrency,
          {
            precision: "exact",
          },
        );
      }
    }

    result.push({
      id: `${dataRow.landingPage ?? ""} ||| ${dataRow.adKey}`,
      index: idx,
      adKey: dataRow.adKey,
      landingPage: dataRow.landingPage,
      name: dataRow.name,
      campaignName: dataRow.campaignName,
      adsetName: dataRow.adsetName,
      adName: dataRow.adName,
      metrics,
    });
  }

  return result;
}
